import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FullUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/FullUserEntity";
import { UserIdentityEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserIdentityEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { removePhoneNumberPrefix, getPhoneNumberDialingCodePrefix, phoneNumberToSend } from "../../../../../utils/CommonUtils";
import {
  getErrorMessage,
  isEmail,
  isNameValid,
  isPhoneNumber,
  isRequired
} from "../../../../../utils/FormUtils";
import {
  showErrorMessage, showUpdateSuccessMessage
} from "../../../../../utils/MessagesUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import PhoneInputWithoutVerification from "../../../Inputs/CustomInputs/PhoneInputWithoutVerification";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import UploadImageInput from "../../../Inputs/CustomInputs/UploadImageInput";
import VerificationPasswordInput from "../../../Inputs/CustomInputs/VerificationPasswordInput";
import VerificationPhoneInput from "../../../Inputs/CustomInputs/VerificationPhoneInput";
import classes from "../WizardForm.module.css";

const EditProfileDetails = (props) => {
  const selectedSites = useSelector((state) => state.user.selectedSites);
  const [errors, setErrors] = useState({});
  const gmtUser = useSelector((state) => state.user?.gmtUser);
  const [formData, setFormData] = useState({
    firstName: gmtUser?.utronUser?.firstName,
    lastName: gmtUser?.utronUser?.lastName,
    dialingCode: getPhoneNumberDialingCodePrefix(gmtUser?.userIdentity?.phoneNumber),
    phoneNumber: removePhoneNumberPrefix(gmtUser?.userIdentity?.phoneNumber),
    originalPhoneNumber: removePhoneNumberPrefix(gmtUser?.userIdentity?.phoneNumber),
    profilePicture: gmtUser?.utronUser?.image,
    isPhoneVerified: true,
    email: gmtUser?.userIdentity?.email,
    isStepSubmitted: false,
    isEditMode: true
  });

  useEffect(() => {
    const hasError = Object.values(errors).some((hasError) => hasError);
    handleCurrentStepValidity(hasError);
  }, [errors]);

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.GENERAL_DETAILS,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const selectedSite = useSelector((state) => state.user?.selectedSite);

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { email, firstName, lastName, dialingCode, phoneNumber, profilePicture } =
      formData;

    let utronUser = { ...gmtUser?.utronUser };
    const userIdentity = new UserIdentityEntity(
      gmtUser?.userIdentity?.id,
      email,
      email,
      dialingCode + phoneNumberToSend(dialingCode, phoneNumber)
    );

    utronUser.firstName = firstName;
    utronUser.lastName = lastName;
    utronUser.image = profilePicture?.split(",")[1];

    const userToUpdate = new FullUserEntity(utronUser, userIdentity);

    if (stateData.isCurrentStepValid) {
      actionsService.updateUser(userToUpdate).then((response) => {
        store.dispatch(commonActions.closeSideModal());
        if (response.data.isSuccess) {
          store.dispatch(userActions.updateGmtUser(response.data));
          showUpdateSuccessMessage();
        } else {
          showErrorMessage(response.data?.error);
        }
      });
    }
  };

  return (
    <form name="EditProfileDetails" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <div className={classes.stepContainer}>
          <div className={classes.stepTitle}>
            {Strings.STEPS_TITLES.GENERAL_DETAILS_TITLE}
          </div>
          <span className={classes.stepSubTitle}>
            {Strings.STEPS_TITLES.GENERAL_DETAILS_SUB_TITLE}
          </span>

          <div className={classes.fileds}>
            <div className={classes.uploadImage}>
              <UploadImageInput
                id={INPUTS_PROPS.PROFILE_PICTURE}
                defaultValue={formData.profilePicture}
                onChange={handleChange}
                image={formData.profilePicture}
              />
            </div>
            <TextInput
              label={Strings.INPUT_LABELS.FIRST_NAME}
              id={INPUTS_PROPS.FIRST_NAME}
              value={formData.firstName}
              onChange={handleChange}
              isStepSubmitted={formData.isStepSubmitted}
              handleError={handleError}
              hasError={!isRequired(formData.firstName).isValid || !isNameValid(formData.firstName).isValid}
              errorMessage={getErrorMessage(isRequired(formData.firstName))}
            />
            <TextInput
              label={Strings.INPUT_LABELS.LAST_NAME}
              id={INPUTS_PROPS.LAST_NAME}
              value={formData.lastName}
              onChange={handleChange}
              isStepSubmitted={formData.isStepSubmitted}
              handleError={handleError}
              hasError={!isRequired(formData.lastName).isValid || !isNameValid(formData.lastName).isValid}
              errorMessage={getErrorMessage(isRequired(formData.lastName))}
            />
            <PhoneInputWithoutVerification
              label={Strings.INPUT_LABELS.PHONE_NUMBER}
              id={INPUTS_PROPS.PHONE_NUMBER}
              phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
              value={formData.phoneNumber}
              isEditMode={formData.isEditMode}
              actionText={
                props.isEditMode ? Strings.CHANGE : Strings.VERIFY /* Strings.CONFIRM_VERIFY */
              }
              dialingCode={formData.dialingCode}
              isPhoneVerified={formData.isPhoneVerified}

              onChange={handleChange}
              handleError={handleError}
              isStepSubmitted={true}
              originalPhoneNumber={formData.originalPhoneNumber}
              hasError={!isRequired(formData.phoneNumber).isValid || !isPhoneNumber(formData.dialingCode + phoneNumberToSend(formData.dialingCode, formData.phoneNumber)).isValid}
              errorMessage={getErrorMessage(isRequired(formData.phoneNumber)) ? getErrorMessage(isRequired(formData.phoneNumber)) : getErrorMessage(isPhoneNumber(formData.dialingCode + phoneNumberToSend(formData.dialingCode, formData.phoneNumber)))}
              isVerifyValidationNeeded={true}
              selectedSites={selectedSites}
            />
            {/* <VerificationPhoneInput
              label={Strings.INPUT_LABELS.PHONE_NUMBER}
              id={INPUTS_PROPS.PHONE_NUMBER}
              phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
              value={formData.phoneNumber}
              isEditMode={formData.isEditMode}
              actionText={
                props.isEditMode ? Strings.CHANGE : Strings.CONFIRM_VERIFY
              }
              dialingCode={formData.dialingCode}
              isPhoneVerified={formData.isPhoneVerified}
              onChange={handleChange}
              handleError={handleError}
              isStepSubmitted={true}
              originalPhoneNumber={formData.originalPhoneNumber}
              hasError={!isRequired(formData.phoneNumber).isValid || !isPhoneNumber(formData.dialingCode + phoneNumberToSend(formData.dialingCode, formData.phoneNumber)).isValid}
              errorMessage={getErrorMessage(isRequired(formData.phoneNumber)) ? getErrorMessage(isRequired(formData.phoneNumber)) : getErrorMessage(isPhoneNumber(formData.dialingCode + phoneNumberToSend(formData.dialingCode, formData.phoneNumber)))}
              selectedSites={selectedSites}
            /> */}
            <TextInput
              label={Strings.INPUT_LABELS.EMAIL}
              id={INPUTS_PROPS.EMAIL}
              value={formData.email}
              isStepSubmitted={formData.isStepSubmitted}
              handleError={handleError}
              onChange={handleChange}
              hasError={!isEmail(formData.email).isValid}
              errorMessage={getErrorMessage(isEmail(formData.email))}
            />
            <VerificationPasswordInput
              label={Strings.INPUT_LABELS.PASSWORD}
              value={"************"}
              additionalDataId={props.additionalDataId}
              codeVerifiedId={INPUTS_PROPS.CODE_VERIFIED}
              isCodeVerified={props.isCodeVerified}
              handleError={handleError}
              userId={gmtUser?.userIdentity?.id}
              // hasError={!isRequired(props.kioskPIN).isValid}
              // errorMessage={getErrorMessage(isRequired(props.kioskPIN))}
              isEditMode={true}
              showTooltip={true}
              tooltipTitle={Strings.TOOLTIP_INFO_TITLE.PASSWORD}
              tooltipText={Strings.TOOLTIP_INFO_TEXT.PASSWORD}
            />
          </div>
        </div>
      </div>
      {stateData.currentStep == stateData.totalSteps && (
        <div className={classes.next}>
          <EllipseButton type="submit">{Strings.SAVE_CHANGES}</EllipseButton>
        </div>
      )}
    </form>
  );
};

export default EditProfileDetails;
